import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CORE_CONFIG_TOKEN } from '@ndk/ng-core/component/core.config';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ICoreConfigInternal } from '@core/core.config.model';

import { IAuthProfile } from './shared/auth-profile.model';

@Injectable()
export class AuthProfileService {
    public onRefreshAuthProfileData$: Subject<IAuthProfile> = new Subject<IAuthProfile>();

    private apiUrl: string;

    constructor(
        @Inject(CORE_CONFIG_TOKEN) config: ICoreConfigInternal,
        private http: HttpClient,
    ) {
        this.apiUrl = `${ config.apiEndpoint }api/users`;
    }

    public getAuthProfile(): Observable<IAuthProfile> {
        return this.http.get(`${ this.apiUrl }/profile`)
            .pipe(tap((response: IAuthProfile) => this.onRefreshAuthProfileData$.next(response)));
    }
}
